import { render } from "./ContentL.vue?vue&type=template&id=30b2a2a0&scoped=true"
import script from "./ContentL.vue?vue&type=script&lang=js"
export * from "./ContentL.vue?vue&type=script&lang=js"

import "./ContentL.vue?vue&type=style&index=0&id=30b2a2a0&lang=scss&scoped=true"

import exportComponent from "/proyectos/programas-de-investigacion/cts-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30b2a2a0"]])

export default __exports__